import { renderPublicHead, defaultOrigin } from './publicSite.js';
import { languages, normalizeLocale } from '../i18n/locales.js';

export function updatePageMetadata(page, language, origin = defaultOrigin) {
  origin = new URL(origin).origin;
  const locale = normalizeLocale(language);
  document.documentElement.lang = languages.find(option => option.code === locale).tag;
  const template = document.createElement('template');
  if (page !== null) {
    template.innerHTML = renderPublicHead(page, locale, origin);
  } else {
    template.innerHTML = '<title data-erion-public-head>E-RION</title><meta data-erion-public-head name="robots" content="noindex,follow">';
  }
  document.head.querySelectorAll('[data-erion-public-head]').forEach(node => node.remove());
  document.head.append(template.content);
}
